import { format } from 'date-fns';
import { Group, Text } from '@optiaxiom/react';

type ModifiedDateCellProps = {
  date: string | Date;
  userId: string;
  userNameMap: Record<string, string>;
  isInstalled?: boolean;
};

export const ModifiedDateCell = ({
  date,
  userId,
  userNameMap,
  isInstalled = false,
}: ModifiedDateCellProps) => {
  const name = userNameMap[userId];
  return (
    <Group flexDirection="column" gap="4" alignItems={name ? 'start' : 'center'}>
      <Text fontSize="sm">{format(new Date(date), 'MMM dd, yyyy')}</Text>
      <Text fontSize="sm" color="fg.tertiary">
        {isInstalled ? 'by Optimizely' : name ? `by ${name}` : '—'}
      </Text>
    </Group>
  );
};
